import React from "react";
import { CircularProgress, Grid } from "@mui/material";

function LoadingScreen() {
	return (
		<Grid
			container
			spacing={2}
			alignItems="center"
			justifyContent={"center"}
			direction="column"
			height="80vh"
			sx={{
				m: 0,
				position: "absolute",
				width: "100vw",
				height: "100vh",
			}}>
			<Grid item>
				<CircularProgress size={90} thickness={0.5} color="secondary" />
			</Grid>
		</Grid>
	);
}
export default LoadingScreen;
